import { ref } from 'vue'

export default () => ({
  atcs: ref([])
})
